import { render, staticRenderFns } from "./ModalGenerateExtractDigital.vue?vue&type=template&id=0dadd7b9"
import script from "./ModalGenerateExtractDigital.vue?vue&type=script&lang=js"
export * from "./ModalGenerateExtractDigital.vue?vue&type=script&lang=js"
import style0 from "./ModalGenerateExtractDigital.vue?vue&type=style&index=0&id=0dadd7b9&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dadd7b9')) {
      api.createRecord('0dadd7b9', component.options)
    } else {
      api.reload('0dadd7b9', component.options)
    }
    module.hot.accept("./ModalGenerateExtractDigital.vue?vue&type=template&id=0dadd7b9", function () {
      api.rerender('0dadd7b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalGenerateExtractDigital.vue"
export default component.exports